import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { ExpandableSection } from '../../_shared/ExpandableSection/ExpandableSection';
import { EventDetailsSection, EventDetailsSectionTitle } from '../EventDetails';
import './Performers.scss';

type Artist = {
    name: string;
};

type ArtistList = Artist[];

export type PerformersProps = {
    headliners?: ArtistList;
    supporters?: ArtistList;
};

export const Performers = ({
    headliners = [],
    supporters = [],
}: PerformersProps) => {
    if (!headliners.length && !supporters.length) {
        return null;
    }

    return (
        <EventDetailsSection ariaLabelledBy="performers">
            <EventDetailsSectionTitle>
                <h2>{gettext('Performers')}</h2>
            </EventDetailsSectionTitle>
            <ExpandableSection
                maxContainerHeight={160}
                buttonTextCollapsed={gettext('Show all performers')}
                buttonTextExpanded={gettext('Hide all performers')}
            >
                <>
                    {headliners.length > 0 && (
                        <>
                            {supporters.length > 0 && (
                                <h3
                                    id="headliners-heading"
                                    className="performers__title"
                                >
                                    {gettext('Headliners')}
                                </h3>
                            )}

                            <ul className="performers__list">
                                {headliners.map(({ name }, i) => (
                                    <li key={i} className="headliners">
                                        {name}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}

                    {supporters.length > 0 && (
                        <>
                            {headliners.length > 0 && (
                                <h3
                                    id="supporters-heading"
                                    className="performers__title"
                                >
                                    {gettext('More Performers')}
                                </h3>
                            )}

                            <ul className="performers__list">
                                {supporters.map(({ name }, i) => (
                                    <li key={i} className="supporters">
                                        {name}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </>
            </ExpandableSection>
        </EventDetailsSection>
    );
};
